import clsx from 'clsx'

const baseStyles = 'py-2 rounded-lg shadow-md flex items-center gap-2 px-4 rounded-md min-w-max'
const defaultColorStyles = 'bg-greenPrimary text-white'
const hoverStyles = 'hover:bg-green-700 transition'
const disabledStyles = 'bg-gray-300 text-gray-600 cursor-not-allowed'

const ButtonComponent = ({ children, className = '', customColorsStyles = '', disabled = false, ...props }) => {
  const colorClasses = disabled
    ? disabledStyles
    : customColorsStyles || defaultColorStyles

  const classNameButton = clsx(
    baseStyles,
    !disabled && hoverStyles,
    colorClasses,
    className
  )

  return (
    <button className={classNameButton} disabled={disabled} {...props}>
      {children}
    </button>
  )
}

export default ButtonComponent
